import React from 'react'
import { Autocomplete, Paper, TextField, InputAdornment, Icon, Box, Popper } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const AdxAutocomplete = ({
  renderInput,
  options,
  icon,
  sx,
  paperSx,
  inputSx,
  label,
  placeholder,
  isErrorShown,
  errorMessage,
  disablePortal = false,
  ...rest
}) => {
  const { componentHeight, palette } = useTheme()

  const CustomPaper = (props) => {
    return <Paper elevation={8} sx={{ my: 1.25, borderRadius: 1.25, ...paperSx }} {...props} />
  }

  return (
    <Box>
      <Autocomplete
        disablePortal={disablePortal}
        renderInput={
          renderInput
            ? renderInput
            : (params) => (
              <TextField
                {...params}
                sx={{
                  height: componentHeight.standard,
                  ...inputSx,
                }}
                label={label ? label : null}
                InputProps={{
                  ...params.InputProps,
                  placeholder,
                  startAdornment: icon ? (
                    <InputAdornment
                      sx={{ height: componentHeight.standard }}
                      position="start"
                    >
                      <Box display="flex" alignItems="center" width={28} height={28} pt={0.25}>
                        <Icon sx={{ fontSize: 20 }}>{icon}</Icon>
                      </Box>
                    </InputAdornment>
                  ) : null,
                }}
              />
            )
        }
        options={options}
        fullWidth
        PaperComponent={CustomPaper}
        ListboxProps={{
          sx: {
            '& .MuiAutocomplete-option[aria-selected=true]': {
              backgroundColor: 'transparent',
              '&.Mui-focused': { backgroundColor: 'gray-background.main' },
            },
            '& .MuiAutocomplete-option[aria-selected=false]': {
              backgroundColor: 'transparent',
              '&.Mui-focused': { backgroundColor: 'gray-background.main' },
            },
            '&::-webkit-scrollbar': { width: '6px' },
            '&::-webkit-scrollbar-thumb': {
              borderRadius: '4.5px',
              backgroundColor: 'rgba(206,208,212)',
            },
          },
        }}
        sx={{
          height: componentHeight.standard,
          '& .MuiOutlinedInput-root': {
            height: componentHeight.standard,
            borderRadius: 1.25,
            py: 0,
            outlineColor: isErrorShown ? palette.error.main : null,
          },
          '& .MuiOutlinedInput-notchedOutline': { borderWidth: 0 },
          '&.Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
            border: 0,
          },
          ...sx,
        }}
        {...rest}
      />
      <Box pt={0.5}>{isErrorShown && errorMessage}</Box>
    </Box>
  )
}

export default AdxAutocomplete
